import React from "react";

const InterestCheckListDetail = ({ item }) => {
    // console.log(Object.entries(item));
    return (
        <>
            {/* HEALTH AND FITNESS */}
            <div className="row">
                <div className="col-4 bg-primary pl-2">
                    <h5>Health and Fitness</h5>
                </div>

                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th style={{ width: "40%" }}>Activity</th>
                            <th style={{ width: "30%" }}>Degree of Interest</th>
                            <th style={{ width: "30%" }}>Participation</th>
                        </tr>
                    </thead>
                    <tbody>
                        {item.health_fitness.map((o, idx) => (
                            <tr key={idx}>
                                <td>
                                    <strong>{o.activity}</strong>
                                </td>
                                <td>
                                    <span className="text-primary">{o.interest}</span>
                                </td>
                                <td>
                                    <ul className="text-primary">
                                        {o.participation.map((i, d) => (
                                            <li key={d}>{i}</li>
                                        ))}
                                    </ul>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {/* Sport */}
            <div className="row">
                <div className="col-4 bg-primary pl-2">
                    <h5>Sport</h5>
                </div>

                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th style={{ width: "40%" }}>Activity</th>
                            <th style={{ width: "30%" }}>Degree of Interest</th>
                            <th style={{ width: "30%" }}>Participation</th>
                        </tr>
                    </thead>
                    <tbody>
                        {item.sports.map((o, idx) => (
                            <tr key={idx}>
                                <td>
                                    <strong>{o.activity}</strong>
                                </td>
                                <td>
                                    <span className="text-primary">{o.interest}</span>
                                </td>
                                <td>
                                    <ul className="text-primary">
                                        {o.participation.map((i, d) => (
                                            <li key={d}>{i}</li>
                                        ))}
                                    </ul>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Creative */}
            <div className="row">
                <div className="col-4 bg-primary pl-2">
                    <h5>Creative</h5>
                </div>

                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th style={{ width: "40%" }}>Activity</th>
                            <th style={{ width: "30%" }}>Degree of Interest</th>
                            <th style={{ width: "30%" }}>Participation</th>
                        </tr>
                    </thead>
                    <tbody>
                        {item.creatives.map((o, idx) => (
                            <tr key={idx}>
                                <td>
                                    <strong>{o.activity}</strong>
                                </td>
                                <td>
                                    <span className="text-primary">{o.interest}</span>
                                </td>
                                <td>
                                    <ul className="text-primary">
                                        {o.participation.map((i, d) => (
                                            <li key={d}>{i}</li>
                                        ))}
                                    </ul>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Productivity at home */}
            <div className="row">
                <div className="col-4 bg-primary pl-2">
                    <h5>Productivity at home</h5>
                </div>

                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th style={{ width: "40%" }}>Activity</th>
                            <th style={{ width: "30%" }}>Degree of Interest</th>
                            <th style={{ width: "30%" }}>Participation</th>
                        </tr>
                    </thead>
                    <tbody>
                        {item.productivity.map((o, idx) => (
                            <tr key={idx}>
                                <td>
                                    <strong>{o.activity}</strong>
                                </td>
                                <td>
                                    <span className="text-primary">{o.interest}</span>
                                </td>
                                <td>
                                    <ul className="text-primary">
                                        {o.participation.map((i, d) => (
                                            <li key={d}>{i}</li>
                                        ))}
                                    </ul>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Leisure at home*/}
            <div className="row">
                <div className="col-4 bg-primary pl-2">
                    <h5>Leisure at home</h5>
                </div>

                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th style={{ width: "40%" }}>Activity</th>
                            <th style={{ width: "30%" }}>Degree of Interest</th>
                            <th style={{ width: "30%" }}>Participation</th>
                        </tr>
                    </thead>
                    <tbody>
                        {item.leisures.map((o, idx) => (
                            <tr key={idx}>
                                <td>
                                    <strong>{o.activity}</strong>
                                </td>
                                <td>
                                    <span className="text-primary">{o.interest}</span>
                                </td>
                                <td>
                                    <ul className="text-primary">
                                        {o.participation.map((i, d) => (
                                            <li key={d}>{i}</li>
                                        ))}
                                    </ul>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Social */}
            <div className="row">
                <div className="col-4 bg-primary pl-2">
                    <h5>Social</h5>
                </div>

                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th style={{ width: "40%" }}>Activity</th>
                            <th style={{ width: "30%" }}>Degree of Interest</th>
                            <th style={{ width: "30%" }}>Participation</th>
                        </tr>
                    </thead>
                    <tbody>
                        {item.social.map((o, idx) => (
                            <tr key={idx}>
                                <td>
                                    <strong>{o.activity}</strong>
                                </td>
                                <td>
                                    <span className="text-primary">{o.interest}</span>
                                </td>
                                <td>
                                    <ul className="text-primary">
                                        {o.participation.map((i, d) => (
                                            <li key={d}>{i}</li>
                                        ))}
                                    </ul>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {/* Outdoor Pursuits */}
            <div className="row">
                <div className="col-4 bg-primary pl-2">
                    <h5>Outdoor Pursuits</h5>
                </div>

                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th style={{ width: "40%" }}>Activity</th>
                            <th style={{ width: "30%" }}>Degree of Interest</th>
                            <th style={{ width: "30%" }}>Participation</th>
                        </tr>
                    </thead>
                    <tbody>
                        {item.out_door.map((o, idx) => (
                            <tr key={idx}>
                                <td>
                                    <strong>{o.activity}</strong>
                                </td>
                                <td>
                                    <span className="text-primary">{o.interest}</span>
                                </td>
                                <td>
                                    <ul className="text-primary">
                                        {o.participation.map((i, d) => (
                                            <li key={d}>{i}</li>
                                        ))}
                                    </ul>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/*Educational */}
            <div className="row">
                <div className="col-4 bg-primary pl-2">
                    <h5>Educational</h5>
                </div>

                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th style={{ width: "40%" }}>Activity</th>
                            <th style={{ width: "30%" }}>Degree of Interest</th>
                            <th style={{ width: "30%" }}>Participation</th>
                        </tr>
                    </thead>
                    <tbody>
                        {item.educational.map((o, idx) => (
                            <tr key={idx}>
                                <td>
                                    <strong>{o.activity}</strong>
                                </td>
                                <td>
                                    <span className="text-primary">{o.interest}</span>
                                </td>
                                <td>
                                    <ul className="text-primary">
                                        {o.participation.map((i, d) => (
                                            <li key={d}>{i}</li>
                                        ))}
                                    </ul>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Out and About /  Entertainment */}
            <div className="row">
                <div className="col-4 bg-primary pl-2">
                    <h5>Out and About / Entertainment</h5>
                </div>

                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th style={{ width: "40%" }}>Activity</th>
                            <th style={{ width: "30%" }}>Degree of Interest</th>
                            <th style={{ width: "30%" }}>Participation</th>
                        </tr>
                    </thead>
                    <tbody>
                        {item.out_about.map((o, idx) => (
                            <tr key={idx}>
                                <td>
                                    <strong>{o.activity}</strong>
                                </td>
                                <td>
                                    <span className="text-primary">{o.interest}</span>
                                </td>
                                <td>
                                    <ul className="text-primary">
                                        {o.participation.map((i, d) => (
                                            <li key={d}>{i}</li>
                                        ))}
                                    </ul>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="row">
                <div className="col-4 bg-primary pl-2">
                    <h5>Interest Summary</h5>
                </div>

                <table className="table table-bordered">
                    <tbody>
                        <tr>
                            <td colSpan="2">
                                <strong>Strong Interests</strong>
                            </td>
                        </tr>
                        <tr>
                            {item.strong_interest.map((s) => (
                                <td style={{ width: "50%" }} key={s}>
                                    <span className="text-primary">{s}</span>
                                </td>
                            ))}
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="row">
                <div className="col-4 bg-primary pl-2">
                    <h5>Action Plan</h5>
                </div>

                <table className="table table-bordered">
                    <tbody>
                        <tr>
                            <td style={{ width: "50%" }}>
                                <strong>SHORTLIST</strong>
                            </td>
                            <td>
                                <strong>ACTION PLAN</strong>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: "50%" }}>
                                <ul>
                                    {item.short_list.map((sl) => (
                                        <li key={sl}>{sl} </li>
                                    ))}
                                </ul>
                            </td>
                            <td>
                                <ul>
                                    {item.action_plans.map((sl) => (
                                        <li key={sl}>{sl} </li>
                                    ))}
                                </ul>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </>
    );
};

export default InterestCheckListDetail;
